const schema = [
  {
    baseUrl: '/cjt',
    displayName: 'Customer journey testing',
    servicename: 'cjt',
    accessor: 'thservices',
    children: 'categories',
  },
  {
    baseUrl: '/testdata',
    displayName: 'Test data',
    servicename: 'testdata',
    accessor: 'thservices',
    children: 'categories',
  },
  {
    baseUrl: '/hosting',
    displayName: 'Test hosting',
    servicename: 'hosting',
    accessor: 'projects',
    children: 'workstream',
  },
  {
    baseUrl: '/tools',
    displayName: 'Tools',
    servicename: 'tools',
    accessor: 'thservices',
    children: 'categories',
  },
  {
    baseUrl: '/testsuites',
    displayName: 'Test suites',
    servicename: 'testsuites',
  },
  {
    baseUrl: '/dashboard',
    displayName: 'Dashboard',
    servicename: 'dashboard',
  }
];

export default schema;
